<template>
	<div>
		<div class="title">
			<h3>通用类型设置&nbsp;&nbsp;<button @click="look_note">备注说明</button></h3>
			<div id="notice">
				<h5>说明:</h5><br>
				<span>1、使用后不能删除,但可以先注销停止使用</span><br>
				<span>2、分为一级类别,和对应二级类别具体名称</span><br>
				<span>3、二级类别在没有使用的情景下可以删除</span><br>
			</div>
		</div>
		<div class="edit-body">
			<div class="edit_left">
				<div class="content" v-show="show_action">
					<div class="content_edit">
						<div class="content_edit_item">
							<h5>一级类别&nbsp;&nbsp;</h5>
							<button class="pre_btn_ok" @click="refresh_data">查询</button>&nbsp;
							<button class="pre_btn_ok" @click="fun_add()">新建</button>&nbsp;
							<button class="pre_btn_ok" @click="fun_save">{{t_action_name}}</button>
						</div>
					</div>
					<div class="content_edit">
						<div class="content_edit_item">
							<label>名称:</label><input type="text" v-model="s_name" @keyup.enter="fun_save" />
						</div>
					</div>
				</div>

				<pre-table class="mytable" ref="file_table" @tab-event="refresh_data" :api_url="load_url"
					:pre_post="load_json" :pre_post_upd="upd_json">
					<!-- 设定关键字和按钮  -->
					<template slot="key_btn">
					</template>
					<!-- 设定标题  -->
					<template slot="tab_title">
						<tr>
							<th>序号</th>
							<th class="left long1">名称</th>
							<th class="short2">状态</th>
							<th class="short2">修改人</th>
							<th class="short">更新时间</th>
							<th class="short" v-show="show_action">操作</th>
						</tr>
					</template>
					<template slot="tab_tr" slot-scope="user">
						<tr v-bind:id="'tr' + user.item.row_num" @click="sel_row(user.item)">
							<td>{{ user.item.row_num }}</td>
							<td class="left long1">{{ user.item.val }}</td>
							<td class="short2">{{ user.item.flag }}</td>
							<td class="short2">{{ user.item.uname }}</td>
							<td class="short">{{ user.item.udate }}</td>
							<td class="short" v-show="show_action">
								<img src="../../assets/image/edit.png" @click="fun_upd(user.item)" />
								<img src="../../assets/image/delete.png" @click="fun_del(user.item.id)" />
							</td>
						</tr>
					</template>
					<!-- 构建新增模板 -->
					<template slot="tab_addorupdate">

					</template>
				</pre-table>
			</div>
			<div class="edit_left">
				<div class="content" v-show="show_action">
					<div class="content_edit">
						<div class="content_edit_item">
							<h5>{{c_name}}&nbsp;&nbsp;分为:&nbsp;&nbsp;</h5>
							<button class="pre_btn_ok" @click="loaddata2()">查询</button>&nbsp;
							<button class="pre_btn_ok" @click="fun_add2()">新建</button>&nbsp;
							<button class="pre_btn_ok" @click="fun_save2">{{t_action_name2}}</button>
						</div>
					</div>
					<div class="content_edit">
						<div class="content_edit_item">
							<label>名称:</label><input type="text" v-model="s_name2" @keyup.enter="fun_save2" />
						</div>
						<div class="content_edit_item">
							<label>简称:</label><input type="text" v-model="s_no2" @keyup.enter="fun_save2" />
						</div>
					</div>
					<!-- <div class="content_edit">
						<div class="content_edit_item">
							<label>名称简称:</label><input type="text" v-model="s_no2" @keyup.enter="fun_save2" />
						</div>

					</div> -->
				</div>
				<div class="temp_content">

					<!-- <label>关键字：</label>
      <input type="text" placeholder="请输入关键字" v-model="key_word" @keyup.enter="fun_add2()" /> -->


					<table class="dataintable">
						<thead>
							<tr>
								<th>序号</th>
								<th class="left short3">一级名称</th>
								<th class="left long1">名称</th>
								<th class="left long1">简称</th>
								<th class="short2">状态</th>
								<th class="short">编辑</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in class_two" :key="index">
								<td>{{ item.row_num }}</td>
								<td class="left short3">{{ item.c_name }}</td>
								<td class="left long1">{{ item.val }}</td>
								<td class="left long1">{{ item.no }}</td>
								<td class="short2">{{ item.flag }}</td>
								<td class="short" v-show="show_action">
									<img src="../../assets/image/edit.png" @click="fun_upd2(item)" />
									<img src="../../assets/image/delete.png" @click="fun_del2(item.id)" />
								</td>
							</tr>
						</tbody>
					</table>

				</div>
			</div>
		</div>
		<!-- 引入模块 -->
	</div>
</template>

<script>
	import api from '@/utils/type.js'
	import {
		api_EasyAdd,
		api_EasyDelete,
		api_EasySelect,
		api_EasyUpdate
	} from '@/utils/api_data.js';

	import {
		Method_EasySelect,
		Method_EasyAdd,
		Method_EasyDelete,
		Method_EasyUpdate
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-table": () => import("../per_old/pre_table_nokey.vue"),
			"pre-table2": () => import("../per_old/pre_table_nokey.vue")
		},
		data() {
			return {
				load_url: '',
				load_json: '',
				upd_json: '',
				key_word: '',
				t_action_name: '',
				t_action: '',
				t_rowid: '',

				s_name: "",

				class_two: [],
				key_word2: '',
				t_action_name2: '',
				t_action2: '',
				t_rowid2: '',

				c_id: '',
				c_name: '',
				s_name2: "",
				s_no2: '',

				show_action: true, //操作控制
				show_note: false, //说明控制
				show_data: false,
				nowpage: '1',
				bak_data: '', //防止重复操作

			};
		},
		created: function() {
			this.fun_init();
			this.loaddata();

			this.fun_init2();
		},
		mounted: function() {
			// var that=this;
			// this.$nextTick(function() {

			// });
		},
		methods: {
			loaddata: function() {
				this.load_url = api.http_method;
				this.load_json = Method_EasySelect('data_classone', '1', '', '');
			},
			refresh_data: function(page, keyword, type) {
				// console.log('刷新结果page=' + page + ' keyword=' + keyword + ' type=' + type);
				let r = (Math.random() + '').substring(0, 4);
				// console.log('随机串='+r);
				this.load_json = Method_EasySelect('data_classone', '1', r);
			},
			fun_init: function() {
				// 这里放每次点击行  需要初始化的数据
				this.t_action_name = '保存';
				this.t_action = 'add';
			},
			fun_add: function() {
				// 展示新增位置
				this.data_clear();
				this.fun_init();
				// this.$refs.file_table.showpop();
			},
			fun_del: function(id) {
				// console.log('删除 id=' + id);
				var con = confirm('您确定要删除当前数据!');
				if (con == true) {
					this.upd_json = Method_EasyDelete('data_classone', id);
				}
			},
			fun_upd: function(item) {
				this.data_clear();
				this.t_action_name = '修改';
				this.t_action = 'upd';
				// console.log(item);

				this.t_rowid = item.id;
				this.s_name = item.val;

				this.c_id = item.id;
				this.c_name = item.val;

				this.loaddata2();
				this.sys_date = item.sys_date;
				// 如果需要就通过弹窗形式编辑数据
				// this.$refs.file_table.showpop();
			},
			data_clear: function() {
				this.t_rowid = '';
				this.s_name = '';

				this.sys_date = '';
			},
			fun_save: function() {
				// console.log('操作：' + this.t_action + ' =' + this.s_name);
				var temp_data = '';
				if (this.t_action == 'add') {

					if (this.s_name == null || String(this.s_name).length == 0 || String(this.s_name).length > 8) {
						this.$message({
							message: '操作不正确,当前名称不能为空或者长度超过8个字节<div class="mtop mdown" > 名称=' + this.s_name +
								'</div>请检查!',
							type: 'warning'
						});
						return;
					}
					temp_data = Method_EasyAdd('data_classone', this.s_name);
					if (this.bak_data == temp_data) {


						this.$message({
							message: '不能重复操作',
							type: 'warning'
						});
						return;
					}
					this.upd_json = temp_data;
					this.bak_data = temp_data;

				} else if (this.t_action == 'upd') {

					temp_data = Method_EasyUpdate('data_classone', this.t_rowid, this.s_name)
					if (this.bak_data == temp_data) {


						this.$message({
							message: '不能重复操作',
							type: 'warning'
						});
						return;
					}
					this.upd_json = temp_data;
					this.bak_data = temp_data;

				} else {

					this.$message({
						message: '未知操作 action=' + this.t_action,
						type: 'warning'
					});
				}
			},
			sel_row: function(ts) {
				this.$refs.file_table.setCurrentRow(ts, 'tr');
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			/*********联动部分***************/
			loaddata2: async function() {
				// console.log('c_id=' + this.c_id);
				let d = await api_EasySelect('data_classtwo', '1', this.c_id);
				// console.log(d);
				this.class_two = [];
				if (Number.parseInt(d.status) == 1) {
					this.class_two = d.data;
					this.fun_init2();
				} else {
					let err = '';
					err = d.msg;
					if (err == '') {
						err = '没有查询到数据!';
					}
					this.$message({
						message: err,
						type: 'success'
					});
				}
			},
			fun_init2: function() {
				// 这里放每次点击行  需要初始化的数据
				this.t_action_name2 = '保存';
				this.t_action2 = 'add';
			},
			fun_add2: function() {
				// 展示新增位置
				this.t_rowid2 = '';
				// this.c_id = '';
				// this.c_name = '';
				this.s_name2 = '';
				this.fun_init2();
				// this.$refs.file_table.showpop();
			},
			fun_del2: async function(id) {
				// console.log('删除 id=' + id);
				var con = confirm('您确定要删除当前数据!');
				if (con == true) {
					let d = await api_EasyDelete('data_classtwo', id);
					if (Number.parseInt(d.status) == 1) {
						this.loaddata2();
					} else {

						this.$message({
							message: d.msg,
							type: 'success'
						});
					}
				}
			},
			fun_upd2: function(item) {
				this.data_clear2();
				this.t_action_name2 = '修改';
				this.t_action2 = 'upd';
				// console.log(item);

				this.t_rowid2 = item.id;
				this.s_name2 = item.val;
				this.c_id = item.c_id;
				this.c_name = item.c_name;
				this.s_no2 = item.no;

				// 如果需要就通过弹窗形式编辑数据
				// this.$refs.file_table.showpop();
			},
			data_clear2: function() {

				this.t_rowid2 = '';
				this.c_id = '';
				this.c_name = '';
				this.s_name2 = '';
			},
			fun_save2: async function() {
				// console.log('操作：' + this.t_action2 + ' =' + this.s_name2);
				var temp_data = '';
				if (this.t_action2 == 'add') {

					if (this.s_name2 == null || String(this.s_name2).length == 0 || String(this.s_name2).length > 8) {

						this.$message({
							message: '操作不正确,当前名称不能为空或者长度超过8个字节<div class="mtop mdown" > 名称=' + this.s_name2 +
								'</div>请检查!',
							type: 'warning'
						});
						return;
					}
					temp_data = 'c_id=' + this.c_id + ' name=' + this.s_name2
					if (this.bak_data == temp_data) {

						this.$message({
							message: '不能重复操作',
							type: 'warning'
						});
						return;
					}
					let d = await api_EasyAdd('data_classtwo', this.c_id, this.s_name2, this.s_no2);
					if (Number.parseInt(d.status) == 1) {
						this.loaddata2();
					} else {
						this.$message({
							message: d.msg,
							type: 'warning'
						});

					}
					this.bak_data = temp_data;

				} else if (this.t_action2 == 'upd') {

					temp_data = 'row_id=' + this.t_rowid2 + ' name=' + this.s_name2
					if (this.bak_data == temp_data) {

						this.$message({
							message: '不能重复操作',
							type: 'warning'
						});
						return;
					}
					let d = await api_EasyUpdate('data_classtwo', this.t_rowid2, this.s_name2, this.s_no2);
					if (Number.parseInt(d.status) == 1) {
						this.loaddata2();
					} else {
						this.$message({
							message: d.msg,
							type: 'warning'
						});
					}
					this.bak_data = temp_data;

				} else {
					this.$message({
						message: '未知操作 action=' + this.t_action,
						type: 'warning'
					});
				}
			},
			sel_row2: function(ts) {
				this.$refs.file_table.setCurrentRow(ts, 'tr2');
			},

		}
	};
</script>
<style scoped>
	.short {
		min-width: 102px !important;
		width: 102px !important;
	}

	.short2 {
		min-width: 72px !important;
		width: 72px !important;
	}

	.short3 {
		min-width: 88px !important;
		width: 88px !important;
	}

	.edit-body {
		display: flex;
	}

	.edit_left {
		display: inline-block;
		width: 48%;
		overflow: hidden;
		vertical-align: top;
		margin-left: 8px;
	}

	.mytable {
		display: flex;
		vertical-align: top;
	}

	img {
		width: 18px;
		height: 18px;
		border: 0px;
		text-align: left;
		/* font-size: 16px; */
		margin-left: 5px;
		margin-right: 5px;
	}

	img:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}
</style>
